import React from 'react'

const Social = () => {
  return (
    <div className='home__social'>
        <a href='https://www.linkedin.com/in/prince-r-3121711ba/' className='home__social-icon' target="_blank">
        <i className='uil uil-linkedin'></i>
        </a>
        
        {/* <a href='' className='home__social-icon' target="_blank">
        <i className='uil uil-dribble'></i>
        </a> */}

        <a href='https://github.com/pengefour1' className='home__social-icon' target="_blank">
        <i className='uil uil-github-alt'></i>
        </a>
      
    </div>
  )
}

export default Social
